import { useQuery } from "@tanstack/react-query";
import { getClient, getCrmClientInfo } from "../Services/API/BaseClientManagement";

export const useBaseClientQuery = (clientId: string) => {
  return useQuery(["baseClient", { clientId }], () => getClient(clientId), {
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!clientId,
  });
};

export const useCrmClientInfoQuery = (clientId: string) => {
  return useQuery(
    ["crmClientInfo", { clientId }],
    async () => {
      const response = await getCrmClientInfo(clientId);
      return response?.[0];
    },
    {
      staleTime: 1000 * 60 * 5, // 5 minutes
      enabled: !!clientId,
    }
  );
};
